import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";
import { notify } from "@/components/framework/notify";
import { t } from "@/i18n";

const useUpdateStripeCustomer = (companyId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["updateStripeCustomer", companyId],
    mutationFn: (customerData) => {
      return apiClient.put(
        `subscriptions/customers`,
        { customer: customerData },
        { params: { companyId } },
      );
    },
    onSuccess: (murationResponse, payload) => {
      queryClient.setQueryData(["subscription", companyId], murationResponse);

      // Refetch payment methods if they were updated
      if (payload?.invoice_settings?.default_payment_method) {
        queryClient.invalidateQueries(["paymentMethods", companyId]);
        notify(
          "success",
          t(
            "subscriptions.notifications.success.default_payment_method_updated",
          ),
        );
      } else {
        notify(
          "success",
          t("subscriptions.notifications.success.subscription_updated"),
        );
      }
    },
    onError: () => {
      notify("error", t("generic.unknown_error"));
    },
  });
};

export { useUpdateStripeCustomer };
